<!--
 * @Author: chj
 * @Date: 2024-10-10 11:16:45
 * @LastEditors: chj
 * @LastEditTime: 2024-10-24 09:57:26
 * @Description: 请填写简介
-->
<template>
  <header :class="bem()">
    <div :class="bem('container')">
      <router-link :class="bem('logo')" to="/" @click.native="closeNav">
        <img :class="bem('logo-icon')" src="~@/assets/images/logo.jpg" alt="" />
        <span :class="bem('logo-title')">全屋互联开放联盟HCOA</span>
      </router-link>
      <app-nav ref="nav" :class="bem('nav')" />
    </div>
  </header>
</template>

<script>
import AppNav from "./AppNav.vue";
export default {
  name: "app-header",
  components: {
    AppNav,
  },
  methods: {
    closeNav() {
      this.$refs.nav.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-header {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: center;
  height: 80px;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  z-index: 899;
  @include devices(laptop) {
    padding: 0 40px;
  }
  @include devices(pad) {
    padding: 0 20px;
  }
  @include devices(phone) {
    height: 68px;
  }
  &__container {
    display: flex;
    justify-content: space-between;
    width: 1440px;
    height: 100%;
    @include devices(laptop) {
      width: 100%;
    }
  }
  &__logo {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    &-icon {
      width: 40px;
      height: 40px;
      @include devices(phone) {
        width: 28px;
        height: 28px;
      }
    }
    &-title {
      padding-left: 10px;
      font-weight: 500;
      font-size: 18px;
      color: #1a1a1a;
    }
  }
}
</style>
